<form-popup [(visible)]="visible"
        (visibleChange)="onVisibleChange($event)"
        (save)="onPopupSaveClick()"
        [titleText]="vendorId ? 'Edit Vendor' : 'New Vendor'"
        [width]="700"
        [isSaveDisabled]="isReadOnly">
    <dx-form class="plain-styled-form" [screenByWidth]="getSizeQualifier">
        <dxi-item itemType="group">
            <dxo-col-count-by-screen
                [xs]="1"
                [sm]="2"
                [md]="2"
                [lg]="2"
            ></dxo-col-count-by-screen>
            <dxi-item [colSpan]="1">
                <dx-select-box
                    label="Status:*"
                    stylingMode='filled'
                    valueExpr="value"
                    displayExpr="text"
                    [items]="vendorStatusOptions"
                    [searchEnabled]="true"
                    [showClearButton]="true"
                    [(value)]="formData.status"
                    [readOnly]="isReadOnly"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-select-box>
            </dxi-item>
            <dxi-item [colSpan]="1">
                <dx-text-box
                    label="ID:*"
                    [(value)]="formData.number"
                    stylingMode='filled'
                    maxLength="20"
                    [readOnly]="isReadOnly"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </dxi-item>
            <dxi-item [colSpan]="2">
                <dx-text-box
                    label="Name:*"
                    [(value)]="formData.name"
                    stylingMode='filled'
                    maxLength="100"
                    [readOnly]="isReadOnly"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </dxi-item>
            <dxi-item [colSpan]="1">
                <dx-select-box
                    [(value)]="formData.serviceTypeId"
                    [dataSource]="serviceTypeDataSource"
                    displayExpr="name"
                    valueExpr="id"
                    [searchEnabled]="true"
                    [showClearButton]="true"
                    label="Service Type:*"
                    stylingMode='filled'
                    [readOnly]="isReadOnly"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-select-box>
            </dxi-item>
            <dxi-item [colSpan]="1">
                <dx-select-box
                    label="Term:*"
                    stylingMode='filled'
                    valueExpr="value"
                    displayExpr="text"
                    [items]="vendorTermOptions"
                    [searchEnabled]="true"
                    [showClearButton]="true"
                    [(value)]="formData.term"
                    [readOnly]="isReadOnly"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-select-box>
            </dxi-item>
            <dxi-item [colSpan]="1">
                <dx-tag-box
                    label="Site:*"
                    [dataSource]="siteDataSource"
                    displayExpr="name"
                    valueExpr="id"
                    [searchEnabled]="true"
                    [showClearButton]="true"
                    stylingMode='filled'
                    [(value)]="formData.siteIds"
                    (onValueChanged)="onSitesChanged($event)"
                    [readOnly]="isReadOnly"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Site is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-tag-box>
            </dxi-item>
            <dxi-item [colSpan]="1">
                <dx-select-box
                    [(value)]="formData.glCodeId"
                    [dataSource]="glCodeDataSource"
                    displayExpr="name"
                    valueExpr="id"
                    [searchEnabled]="true"
                    [showClearButton]="true"
                    label="Default GL Code:"
                    stylingMode='filled'
                    [readOnly]="isReadOnly"
                    [disabled]="!formData.siteIds?.length"
                    [placeholder]="!formData.siteIds?.length ? 'Select a Site first' : ''"
                ></dx-select-box>
            </dxi-item>
            <dxi-item [colSpan]="2">
                <dx-text-box
                    stylingMode="filled"
                    valueChangeEvent="keyup input change"
                    label="Address:*"
                    [(value)]="formData.address"
                    maxLength="200"
                    [readOnly]="isReadOnly"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                    <dxi-button
                        name="icon"
                        location="before"
                        [options]="{ icon: 'home', elementAttr: { class: 'form-editor-icon' }, stylingMode: 'text' }"
                    ></dxi-button>
                </dx-text-box>
            </dxi-item>
            <dxi-item [colSpan]="1">
                <dx-text-box
                    stylingMode="filled"
                    valueChangeEvent="keyup input change"
                    label="Phone #:"
                    mask="(000) 000-0000"
                    [(value)]="formData.phone"
                    maxLength="20"                    
                    [readOnly]="isReadOnly"
                >
                    <dxi-button
                        name="icon"
                        location="before"
                        [options]="{ icon: 'tel', elementAttr: { class: 'form-editor-icon' }, stylingMode: 'text' }"
                    ></dxi-button>
                </dx-text-box>
            </dxi-item>
            <dxi-item [colSpan]="1">
                <dx-text-box
                    stylingMode="filled"
                    valueChangeEvent="keyup input change"
                    label="Email:"
                    [(value)]="formData.email"
                    maxLength="150"
                    [readOnly]="isReadOnly"
                >
                    <dxi-button
                        name="icon"
                        location="before"
                        [options]="{ icon: 'email', elementAttr: { class: 'form-editor-icon' }, stylingMode: 'text' }"
                    ></dxi-button>
                </dx-text-box>
            </dxi-item>
            <dxi-item [colSpan]="1">
                <dxo-label [visible]="false"></dxo-label>
                <pictured-item-select-box
                    label="Main Contact:"
                    [(value)]="formData.contactId"
                    [dataSource]="vendorEmployeeDataSource"
                    [readOnly]="isReadOnly || vendorId === null"
                    [validators]="[]">
                </pictured-item-select-box>
            </dxi-item>
            <dxi-item [colSpan]="1">
                <dx-date-box
                    [(value)]="formData.contractExpirationDate"
                    label="Contract Expiry Date:"
                    stylingMode="filled"
                    [placeholder]="dateFormat"
                    [displayFormat]="dateFormat"
                    pickerType="calendar"
                    [readOnly]="isReadOnly"
                ></dx-date-box>
            </dxi-item>
            <dxi-item [colSpan]="2">
                <dxo-label text="Vendor Contract"></dxo-label>
                <file-upload
                    [value]="newFiles" (valueChange)="onFilesChanged($event)"
                    [maxFileSize]="maxFileSize"
                    [maxFileNumber]="maxFileNumber"
                    [(existingFiles)]="existingFiles"
                    [filesToRemove]="filesToRemove" (filesToRemoveChange)="onFilesToRemoveChanged($event)"
                    [isReadOnly]="isReadOnly">
                </file-upload>
            </dxi-item>
        </dxi-item>
    </dx-form>
</form-popup>